import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100px;
`;
export const BtnsWrapper = styled.div`
  display: flex;
  gap: 25px;
`;

export const CloseBtn = styled.div`
  font-size: 25px;
  margin-bottom: 10px;
  text-align: left;
  cursor: pointer;
`;
export const Title = styled.div`
  font-size: 25px;
  margin-bottom: 10px;
  text-align: right;
`;
export const ModalHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
`;
